import { motion } from "framer-motion";

export default function Services() {
  const services = [
    {
      icon: "☀️",
      title: "Solar Panel Installation",
      description:
        "Professional installation of high-efficiency solar panels for maximum energy generation.",
      features: ["Fast installation", "Warranty included", "Expert support"],
    },
    {
      icon: "🔋",
      title: "Battery Storage",
      description:
        "Store excess energy with advanced battery systems for 24/7 power supply.",
      features: ["Day & night power", "Smart monitoring", "Long lifespan"],
    },
    {
      icon: "📊",
      title: "Energy Monitoring",
      description:
        "Real-time monitoring dashboard to track your energy production and savings.",
      features: ["Live analytics", "Mobile app", "Instant alerts"],
    },
    {
      icon: "🛠️",
      title: "Maintenance & Support",
      description:
        "Comprehensive maintenance plans to keep your system running at peak efficiency.",
      features: ["24/7 support", "Regular checkups", "Emergency repairs"],
    },
    {
      icon: "💡",
      title: "Smart Home Integration",
      description:
        "Integrate solar with your smart home for automated energy management.",
      features: ["AI optimization", "Voice control", "Auto-switching"],
    },
    {
      icon: "🌍",
      title: "Eco Consulting",
      description:
        "Expert consultation on reducing your carbon footprint with renewable energy.",
      features: ["Custom plans", "ROI analysis", "Tax benefits"],
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <>
  
   
    <section
  id="services"
  className="py-20 bg-black"
  aria-label="Solar Services in Sukkur" style={{
          backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(22,163,74,0.1) 100%), 
                            url('../../assets/s1.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
>
  <div className="max-w-7xl mx-auto px-6">

    {/* SEO Header */}
    <div className="text-center mb-16">
      <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
        Solar Panel Services in Sukkur
      </h2>

      <p className="text-white/60 text-lg max-w-2xl mx-auto">
        Solidera Energy provides complete solar solutions in Sukkur, Rohri & Khairpur 
        including installation, battery systems, maintenance and energy monitoring.
      </p>
    </div>

    {/* Services */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {services.map((service, index) => (
        <div key={index} className="p-8 rounded-2xl bg-slate-900 border border-orange-500/20">

          {/* Icon */}
          <div className="text-4xl mb-4">{service.icon}</div>

          {/* SEO Title */}
          <h3 className="text-xl font-bold text-white mb-3">
            {service.title} in Sukkur
          </h3>

          {/* Description */}
          <p className="text-white/60 text-sm mb-4">
            {service.description}
          </p>

          {/* Features */}
          <ul className="space-y-2 mb-4">
            {service.features.map((feature, idx) => (
              <li key={idx} className="text-white/70 text-sm">
                ✔ {feature}
              </li>
            ))}
          </ul>

          {/* CTA */}
          <a
            href="tel:+923337111075"
            className="text-orange-400 font-semibold text-sm"
          >
            📞 Get Service Now
          </a>

        </div>
      ))}
    </div>

    {/* Strong CTA */}
    <div className="mt-16 text-center">
      <h3 className="text-2xl font-bold text-white mb-4">
        Looking for Solar Installation in Sukkur?
      </h3>

      <p className="text-white/60 mb-6">
        Contact Solidera Energy for affordable solar systems and expert installation.
      </p>

      <a
        href="https://wa.me/923337111075"
        target="_blank"
        className="px-8 py-3 bg-orange-500 text-black font-bold rounded-lg"
      >
        💬 Get Free Consultation
      </a>
    </div>

  </div>
</section>
     </>
  );
}
